import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { v4 as uuidv4 } from 'uuid';

/**
 * Store dla zarządzania logo w projekcie
 */
const useLogoStore = create(
  persist(
    (set, get) => ({
      // Stan logo
      logoItems: {}, // { id: { id, imageUrl, x, y, scale, opacity, width, height } }
      selectedLogoId: null,
      isDraggingLogo: false,
      dragStartPos: null,

      // Akcje
      addLogoItem: (imageUrl, position = { x: 400, y: 300 }) => {
        const logoId = uuidv4();
        // Load image to get dimensions
        const img = new Image();
        img.onload = () => {
          const newLogoItem = {
            id: logoId,
            imageUrl: imageUrl,
            x: position.x,
            y: position.y,
            scale: 1.0,
            opacity: 0.8,
            width: img.width,
            height: img.height,
            originalWidth: img.width,
            originalHeight: img.height
          };
          set((state) => ({ logoItems: { ...state.logoItems, [logoId]: newLogoItem }, selectedLogoId: logoId }));
        };
        img.src = imageUrl;
        return logoId;
      },
      removeLogoItem: (logoId) => {
        set((state) => {
          const newItems = { ...state.logoItems };
          delete newItems[logoId];
          return { logoItems: newItems, selectedLogoId: state.selectedLogoId === logoId ? null : state.selectedLogoId };
        });
      },
      updateLogoItem: (logoId, updates) => {
        set((state) => ({
          logoItems: {
            ...state.logoItems,
            [logoId]: { ...state.logoItems[logoId], ...updates }
          }
        }));
      },
      selectLogoItem: (logoId) => {
        set({ selectedLogoId: logoId });
      },
      clearLogoSelection: () => {
        set({ selectedLogoId: null });
      },

      // Dragging
      startDraggingLogo: (logoId, startPos) => {
        set({ isDraggingLogo: true, selectedLogoId: logoId, dragStartPos: startPos });
      },
      updateDraggingLogo: (newPos) => {
        const { isDraggingLogo, selectedLogoId } = get();
        if (!isDraggingLogo || !selectedLogoId) return;

        get().updateLogoItem(selectedLogoId, { x: newPos.x, y: newPos.y });
      },
      stopDraggingLogo: () => {
        set({ isDraggingLogo: false, dragStartPos: null });
      },

      // Scale with aspect ratio
      scaleLogoItem: (logoId, scaleFactor) => {
        const item = get().logoItems[logoId];
        if (!item) return;
        const newScale = Math.max(0.1, Math.min(5.0, item.scale * scaleFactor));
        get().updateLogoItem(logoId, { scale: newScale });
      },

      // Clear all logos
      clearAllLogos: () => {
        set({ logoItems: {}, selectedLogoId: null, isDraggingLogo: false, dragStartPos: null });
      }
    }),
    {
      name: 'floorcraft-logo-storage',
      version: 2,
      migrate: () => ({}),
      partialize: () => ({}),
    }
  )
);

export default useLogoStore;